import { Badge } from "@runcheetah/ui";
import { cn } from "@/lib/utils";

export interface StatusPillProps {
  label: string;
  className?: string;
}

export function StatusPill({ label, className }: StatusPillProps) {
  return (
    <Badge variant="outline" className={cn("capitalize", className)}>
      {label}
    </Badge>
  );
}
